import Illustration from '../components/Illustration/Illustration';

const Tent = Illustration(
  'tent',
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M122.221 33.444a7.895 7.895 0 0 1-5.449-.614c-2.886-1.401-5.275-4.445-6.693-8.468a24.583 24.583 0 0 1-.664-12.964 19.47 19.47 0 0 1 2.886-6.867 11.561 11.561 0 0 1 4.711-4.106 22.588 22.588 0 0 0-2.007 5.59 26.714 26.714 0 0 0 .73 14.1c1.493 4.371 4.089 7.69 7.233 9.215a8.792 8.792 0 0 0 4.23.913 10.004 10.004 0 0 1-4.977 3.201ZM38.782 150.425H2.412C18.62 125.559 24.84 86.51 26.79 41.373l11.993 109.052Zm39.497 0H41.942L29.95 41.373c14.905 45.975 27.595 75.685 48.33 109.052Zm24.65-109.052H32.661c12.267 38.9 28.549 75.403 49.591 109.052h65.607c-23.357-37.954-41.861-74.98-44.93-109.052Z"
  />
);

export default Tent;
